var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-wrapper",class:{'services-page': _vm.$root.isService},attrs:{"id":"app"}},[(_vm.$root.isAdmin())?_c('Panel'):_vm._e(),_c('Header'),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }